import React, { memo } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { UiButton } from '@shared/ui';

import cls from '../MeasurementsModal.module.css';
import { useMeasurementsModalFooter } from './useMeasurementsModalFooter';

export const MeasurementsModalFooter = memo(({ onHideModal }) => {
    const { onSubmit, onDelete, isEdit, isEdited } = useMeasurementsModalFooter(onHideModal);

    const { t } = useTranslation();

    return (
        <div
            className={classNames(cls.footer, {
                [cls.editMode]: isEdit,
            })}
        >
            {isEdit ? (
                <UiButton
                    onClick={onDelete}
                    btnColor="danger"
                    btnText={t('MeasurementsModalFooter.return.deleteButton')}
                />
            ) : (
                <UiButton
                    onClick={() => onHideModal(isEdited)}
                    btnColor="secondary"
                    btnText={t('MeasurementsModalFooter.return.cancelButton')}
                />
            )}
            <UiButton onClick={onSubmit} btnText={t('MeasurementsModalFooter.return.saveButton')} />
        </div>
    );
});
